var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "validation-observer",
    { ref: "denyPaymentFormRef", attrs: { novalidate: "", tag: "form" } },
    [
      _c("div", { staticClass: "mx-4 mt-4" }, [
        _c("div", { staticClass: "row mb-3 pt-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("icon-view", {
                attrs: {
                  icon: "fas fa-times-circle",
                  "icon-background": "#d7383f",
                  "icon-color": "#fff",
                  "icon-size": "14px",
                  title: "Denegar pago",
                  variant: "custom-icon-view"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-text-area", {
                          attrs: {
                            id: "txtCommentDenyPayment",
                            "custom-error-msg": "Debe completar campo.",
                            error: errors[0],
                            label: "Comentario:",
                            maxlength: 500,
                            "show-char-count": ""
                          },
                          model: {
                            value: _vm.comment,
                            callback: function($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3 mt-md-0 mt-sm-3 pb-3" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex align-items-center justify-content-md-end justify-content-sm-none"
            },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    id: "btnCancel",
                    i: "fas fa-times-circle",
                    variant: "outline-danger btn-cancel danger px-3 mr-2"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onCancel()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "action-button",
                {
                  attrs: {
                    id: "btnConfirm",
                    i: "fas fa-save",
                    variant: "success px-3"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onConfirm()
                    }
                  }
                },
                [_vm._v(" Guardar ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }